<template>
    <div id="order_review">
        <br class="hidden-xs clear"/>
        <h2 class="text-center">
            Redirecting you to amazon pay
            <br>If you are not redirected within 10 seconds please <a href="#" class="amazon-clicker cursor-pointer"> click here </a>
            <div hidden class="hidden">
                <div hidden class="hidden" ref="AmazonPayButtonRef" id="AmazonPayButton"></div>
            </div>
        </h2>
    </div>
</template>
<script>    
    export default {
        mounted() {
            this.RenderAmazonPayButton();
        },
        methods: {
            RenderAmazonPayButton()
            {
                let vm = this;
                axios.post('/ajax/get_amazon_pay_button', {
                    data: 5,
                })
                .then(function (response) {
                    response.data.createCheckoutSessionConfig.payloadJSON = JSON.stringify(response.data.createCheckoutSessionConfig.payloadJSON);
                    let amazon_pay_button = amazon.Pay.renderButton('#AmazonPayButton', response.data);
                    vm.$refs.AmazonPayButtonRef.click();
                })
                .catch(function (error) {
                    console.log(error);
                    // show error page.
                });
            },
        }
    }
</script>
<style lang="scss" scoped>

</style>